import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Firebase
import { db } from "../firebase";
import { collection, doc, setDoc } from "firebase/firestore";


function CrearCiudad() {
  const navigate = useNavigate();

  // Estados
  const [nombreInput, setNombre] = useState("");
  const [kmInput, setKm] = useState("");

  // Handlers
  const handleNombreChange = (e) => setNombre(e.target.value);
  const handleKmChange = (e) => setKm(e.target.value);

  // 🚀 Crear Ciudad en Firestore
  const handleCreateCiudad = async (e) => {
    e.preventDefault();

    try {
      const ciudadesRef = collection(db, "ciudades");
      const newCiudadDocRef = doc(ciudadesRef);

      await setDoc(newCiudadDocRef, {
        id: newCiudadDocRef.id,
        nombre: nombreInput,
        km: kmInput,
      });

      alert("Ciudad creada correctamente");
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className="general-container">
      <div className="form-container">
        <form>
          <h3>Crear Ciudad</h3>

          {/* Nombre */}
          <div className="input-container">
            <input value={nombreInput} onChange={handleNombreChange} />
            <label className={nombreInput && "filled"}>Nombre de la Ciudad</label>
          </div>

          {/* Km */}
          <div className="input-container">
            <input value={kmInput} onChange={handleKmChange} />
            <label className={kmInput && "filled"}>Km</label>
          </div>

          <button type="submit" onClick={handleCreateCiudad} className="general-btn">
            Crear Ciudad
          </button>
        </form>
      </div>
       <div style={{ 
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        marginTop: '60px', // Espacio respecto al mapa
        textAlign: 'center'
      }}>

      </div>
    </section>
  );
}

export default CrearCiudad;